import script from "./SendFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./SendFeedback.vue?vue&type=script&setup=true&lang=js"

import "./SendFeedback.vue?vue&type=style&index=0&id=4bdbcd74&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bdbcd74"]])

export default __exports__